import Vue from 'vue'

import RbHeader from '@/elements/header/header.vue'
Vue.component('rb-header', RbHeader)

import RbHeaderMessageBarItem from '@/elements/header/message-bar-item/message-bar-item.vue'
Vue.component('rb-header-message-bar-item', RbHeaderMessageBarItem)

import RbHeaderPromoStripe from '@/elements/header/promo-stripe/promo-stripe.vue'
Vue.component('rb-header-promo-stripe', RbHeaderPromoStripe)

import RbConditionalContent from '@/elements/header/conditional-content/conditional-content.vue'
Vue.component('rb-conditional-content', RbConditionalContent)

import RbConditionalContentWrapper from '@/elements/header/conditional-content/rb-conditional-content-wrapper.vue'
Vue.component('rb-conditional-content-wrapper', RbConditionalContentWrapper)

import RbPromoSubstitute from '@/elements/header/promo-stripe/promo-substitute.vue'
Vue.component('rb-promo-substitute', RbPromoSubstitute)

import RbHeaderMainMenuItem from '@/elements/header/main-menu-item/main-menu-item.vue'
Vue.component('rb-header-main-menu-item', RbHeaderMainMenuItem)

import RbHeaderProductSlide from '@/elements/header/product-slide/product-slide.vue'
Vue.component('rb-header-product-slide', RbHeaderProductSlide)

import RbHeaderProductSlideWithParams from '@/elements/header/product-slide/product-slide-with-params.vue'
Vue.component('rb-header-product-slide-with-params', RbHeaderProductSlideWithParams)

const RbGenesys = () => import('@/elements/genesys/rb-genesys.vue')
Vue.component('rb-genesys', RbGenesys)

import RbPushNotificationPopup from '@/elements/push-notification-popup/push-notification-popup.vue'
Vue.component('rb-push-notification-popup', RbPushNotificationPopup)

import RbHeaderBanner from '@/elements/header/banner/header-banner.vue'
Vue.component('rb-header-banner', RbHeaderBanner)

const RbHeaderProductCarousel = () =>
  import(
    /* webpackChunkName: "header-editorial-chunk" */ '@/elements/header/product-carousel/product-carousel.vue'
  )

Vue.component('rb-header-product-carousel', RbHeaderProductCarousel)

const RbHeaderEditorialWall = () =>
  import(
    /* webpackChunkName: "header-editorial-chunk" */ '@/elements/header/editorial-wall/editorial-wall.vue'
  )

Vue.component('rb-header-editorial-wall', RbHeaderEditorialWall)

import RbNewsletterModal from '@/elements/newsletter-modal/newsletter-modal.lazy.vue'
Vue.component('rb-newsletter-modal', RbNewsletterModal)

import RBPopularSearch from '@/elements/header/search/rb-popular-search.vue'
Vue.component('rb-popular-search', RBPopularSearch)
